import { render, staticRenderFns } from "./CMCourseRow.vue?vue&type=template&id=5b7edcc2&scoped=true&lang=pug&"
import script from "./CMCourseRow.vue?vue&type=script&lang=js&"
export * from "./CMCourseRow.vue?vue&type=script&lang=js&"
import style0 from "./CMCourseRow.vue?vue&type=style&index=0&id=5b7edcc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7edcc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VCol,VIcon,VMenu,VTooltip})
